module.exports = __webpack_public_path__ + "static/subset-UniNeueRegular-e73b8a68a94e59f4103fd340f93b6502.woff2";